<script setup>

import CelluleDonneesGraphique from './CelluleDonneesGraphique.vue'

const { graphique } = defineProps({
	graphique: Object
});

</script>

<template>
	<div class="editeur-graphique">
		<button 
		  class="bouton fa-solid fa-chart-line"
		  v-tooltip="'Afficher le graphique'"
		  @click="$emit('desactivationModeEdition')">
		</button>
		<label class="titre-zone">Données du graphique</label>
		<div class="donnees-graphique"
			:style="`grid-template-columns: repeat(${1 + graphique.axePrincipal.valeurs.length}, max-content);`" >
			<CelluleDonneesGraphique 
				:graphique="graphique"
				:element="graphique.axePrincipal" 
				:type="'AxePrincipal'"
				:indice="0" />
			<CelluleDonneesGraphique v-for="valeur in graphique.axePrincipal.valeurs"
				class="valeur-axe"
				:graphique="graphique"
				:element="valeur"
				:indice="0"
				/>				
			<template v-for="serie in graphique.series">
				<CelluleDonneesGraphique 
					:graphique="graphique"
					:element="serie" 
					:indice="graphique.series.indexOf(serie)" />
				<CelluleDonneesGraphique v-for="valeur in serie.valeurs" 
					:graphique="graphique"
					:element="valeur" 
					:indice="graphique.series.indexOf(serie)" />
			</template>
		</div>
	</div>
</template>

<style scoped>

.editeur-graphique {
	display: flex;
	flex-direction: column;
}

.donnees-graphique {
	display: grid;
	grid-gap:1px;
	justify-content: start;
	margin-top: 10px;
}

.titre-zone {
	margin-top: 12px;
	text-decoration: underline;
	font-weight: 600;
}

.valeur-axe {
	background: whitesmoke;
}

</style>